import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "loops",
    name: "%{BKY_CATLOOPS}",
    colour: themeWorkspace.categoryStyles.loop_category.colour,
    imageName: "/toolbox-imgs/sync-solid.svg",
    id: "31",
    contents: [
      {
        kind: "block",
        type: "controls_repeat_ext",
        inputs: {
          TIMES: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 10,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "controls_whileUntil",
        fields: {
          MODE: "WHILE",
        },
      },
      {
        kind: "block",
        type: "controls_for",
        fields: {
          VAR: {
            name: "i",
            type: "",
          },
        },
        inputs: {
          FROM: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
          TO: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 10,
              },
            },
          },
          BY: {
            shadow: {
              type: "math_number",
              fields: {
                NUM: 1,
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "controls_forEach",
        fields: {
          VAR: {
            name: "i",
            type: "",
          },
        },
      },
      {
        kind: "block",
        type: "controls_flow_statements",
        fields: {
          FLOW: "BREAK",
        },
      },
    ],
  };
}
